<bug-bic-badge [instanceId]="bugBicInstanceId" [position]="'rightMiddle'"
               [offset]="-90"
               [userMail]="stateConfigService.user?.mail ?? ''"></bug-bic-badge>

@if (hasTouchScreen) {
  <div
    class="flex justify-center items-center w-full h-screen bg-gradient-to-br from-blue from-0% via-[#042E3F] via-15% to-green to-90% pt-16 pb-32">
    <div class="bg-white rounded-md mx-6 my-8 h-full w-full overflow-auto gap-8">
      <div class="flex w-full flex-col justify-center items-center">
        <img class="w-56 h-56 " height="224" ngSrc="assets/logo_gradient.svg" width="224">
        <a class="text-[30px] font-bold font-brand text-blue -mt-6">planBIC</a>
      </div>
      <div class="flex flex-col w-full- h-full p-4">
        <div class="flex flex-col text-center text-base text-medium mt-4 px-8">Unsere App ist derzeit leider nicht für
          Mobilgeräte optimiert.
        </div>
        <div class="flex flex-col text-base text-center mt-4 px-6">Zur optimalen Nutzung empfehlen wir Laptops oder
          Tablets mit einer
          Auflösung von 1080 x 1920 Pixeln oder mehr.
        </div>
        <div class="text-center text-base mt-6 px-6">
          Weitere Informationen zur App und Hardwarevoraussetzungen finden Sie
          <a class="text-green underline" href="https://www.thinkbic.de/" rel="noopener noreferrer"
             target="_blank">hier</a>!
        </div>
      </div>
    </div>
  </div>
}


@if (!hasTouchScreen) {
  <div class="flex h-full w-full flex-col items-start justify-start bg-white ">
    <div class="flex h-full w-full flex-row overflow-hidden shadow-full">
      @if (authService.isLoggedIn()) {
        <div
          class="flex flex-col justify-between bg-blue shadow-full text-white w-[272px]  h-full">
          <div class="flex flex-col h-full">
            <!--        Sidebar with unselected project-->
            @if (authService.isLoggedIn() && stateConfigService.selectedProject != undefined) {
              <div
                class="flex flex-col h-full overflow-x-hidden w-[272px]">
                @if (stateConfigService.selectedOrganisation && stateConfigService.selectedOrganisation.logoUrl) {
                  <div class="flex flex-row justify-center items-center pb-5 pt-4">
                    <div class="flex flex-col justify-start items-center gap-1">
                      <img [src]="stateConfigService.selectedOrganisation.logoUrl"
                           alt="thinkBIC" class="h-[76px] xl:h-[76px] hover:cursor-pointer">
                      <div class="text-lg font-extrabold font-brand">planBIC</div>
                    </div>
                  </div>
                } @else {
                  <div class="flex flex-row justify-center items-center pb-5 pt-4">
                    <div class="flex flex-col justify-start items-center gap-1">
                      <img alt="thinkBIC" class="h-[76px] xl:h-[76px] hover:cursor-pointer" src="assets/logo_white.svg">
                      <div class="text-lg font-extrabold font-brand">planBIC</div>
                    </div>
                  </div>
                }
                <app-navbar class="flex flex-col w-full"></app-navbar>
                <app-sidebar [(opened)]="sidebarOpened"
                             class="flex flex-col h-full justify-between content-between overflow-hidden w-[272px] pt-1 sidebar">
                  <div class="flex flex-col gap-1 w-full">
                    <div class="font-medium pt-2 pl-6 text-xs text-gray-400">Allgemein</div>
                    <app-sidebar-item [collapsed]="sidebarCollapsed" [icon]="faGrid2"
                                      [opened]="sidebarOpened"
                                      [routerLink]="['projects', stateConfigService.selectedProject.id, 'dashboard']"
                                      [selected]="'dashboard'"
                                      [title]="sidebarCollapsed ? '' : 'Dashboard'"
                                      (click)="$event.stopPropagation()"
                                      class="w-full"></app-sidebar-item>

                    <!--          Files-->
                    <app-sidebar-item [collapsed]="sidebarCollapsed" [icon]="faFolderOpen" [opened]="sidebarOpened"
                                      (click)="$event.stopPropagation()" [queryParamsHandling]="'merge'"
                                      [queryParams]="{lph: undefined}"
                                      [routerLink]="['projects', stateConfigService.selectedProject.id, 'files']"
                                      [selected]="'/files'"
                                      [title]="sidebarCollapsed ? '' : 'Dateien'"
                                      class="w-full"></app-sidebar-item>
                    <!--          Tasks-->
                    <app-sidebar-item [collapsed]="sidebarCollapsed" [icon]="faClipboardCheck" [opened]="sidebarOpened"
                                      [routerLink]="['projects', stateConfigService.selectedProject.id, 'tasks']"
                                      [selected]="'tasks'" class="w-full"
                                      (click)="$event.stopPropagation()"
                                      title="Tasks"></app-sidebar-item>
                    <!--          Bericht-->
                    <app-sidebar-item [collapsed]="sidebarCollapsed" [icon]="faReport" [opened]="sidebarOpened"
                                      [routerLink]="['projects', stateConfigService.selectedProject.id, 'reports']"
                                      [selected]="'reports'" [title]="sidebarCollapsed ? '' : 'Berichte'"
                                      (click)="$event.stopPropagation()"
                                      class="w-full"></app-sidebar-item>
                    <div class="font-medium pt-2 pl-6 text-xs text-gray-400">Prüfungen</div>

                    <!--          myCheck (Tabs innerhalb der Ansicht, siehe MyCheckHubComponent) -->
                    <app-sidebar-item [alsoSelectedFor]="['check-runs']" [collapsed]="sidebarCollapsed"
                                      [icon]="faClipboardList" [opened]="sidebarOpened"
                                      [routerLink]="['projects', stateConfigService.selectedProject.id, 'my-checks']"
                                      [selected]="'my-checks'" [title]="sidebarCollapsed ? '' : 'myCheck'"
                                      (click)="$event.stopPropagation()"
                                      class="w-full"></app-sidebar-item>
                    <!-- All in check -->
                    <app-sidebar-item [collapsed]="sidebarCollapsed" [icon]="faChartPieSimple" [opened]="sidebarOpened"
                                      [routerLink]="['projects', stateConfigService.selectedProject.id, 'all-in-check']"
                                      [selected]="'all-in-check'" [title]="sidebarCollapsed ? '' : 'All-In Check'"
                                      (click)="$event.stopPropagation()"
                                      class="w-full"></app-sidebar-item>
                    <!--            HOAI Check-->
                    <!--              <app-sidebar-item class="w-full" [opened]="sidebarOpened" [collapsed]="sidebarCollapsed"-->
                    <!--                                [title]="sidebarCollapsed ? '' : 'HOAI-Check'"-->
                    <!--                                [icon]="faMemoCircleCheck" [selected]="'hoai'"-->
                    <!--                                [routerLink]="['projects', stateConfigService.selectedProject.id, 'hoai']"></app-sidebar-item>-->
                    <!--            BIM Basis Check-->
                    <!--              <app-sidebar-item class="w-full" [opened]="sidebarOpened" [collapsed]="sidebarCollapsed"-->
                    <!--                                title="BIM-Basis-Check"-->
                    <!--                                [icon]="faCube" [selected]="'bim-basis-check'"-->
                    <!--                                [routerLink]="['projects', stateConfigService.selectedProject.id, 'bim-basis-check']"-->
                    <!--                                [beta]="false" [ifc]="true"-->
                    <!--                                *ngIf="stateConfigService.selectedProject.isBIM"></app-sidebar-item>-->
                    <!--            LOI Check-->
                    <!--              <app-sidebar-item class="w-full" [opened]="sidebarOpened" [collapsed]="sidebarCollapsed" title="LOI-Check"-->
                    <!--                                [icon]="faCircleInfo" [selected]="'loi-check'"-->
                    <!--                                [routerLink]="['projects', stateConfigService.selectedProject.id, 'loi-check']"-->
                    <!--                                [beta]="false" *ngIf="stateConfigService.selectedProject.isBIM"></app-sidebar-item>-->
                    <!--            Quality Check-->
                    <app-sidebar-item [beta]="false" [collapsed]="sidebarCollapsed" [icon]="faBadgeCheck"
                                      [opened]="sidebarOpened"
                                      [routerLink]="['projects', stateConfigService.selectedProject.id, 'quality']"
                                      [selected]="'quality'" [title]="sidebarCollapsed ? '' : 'All-Right Check'"
                                      (click)="$event.stopPropagation()"
                                      class="w-full"></app-sidebar-item>

                    <!--          Angeheftete Checks (Shortcuts) -->
                    <app-pinned-checks-sidebar [collapsed]="sidebarCollapsed" [opened]="sidebarOpened">
                    </app-pinned-checks-sidebar>
                    <!--              <app-sidebar-item class="w-full" [opened]="sidebarOpened" [collapsed]="sidebarCollapsed"-->
                    <!--                                *ngIf="stateConfigService.selectedProject.id == 45 || stateConfigService.selectedProject.id == 44 || stateConfigService.selectedProject.id == 72 || stateConfigService.selectedProject.id == 77"-->
                    <!--                                [title]="sidebarCollapsed ? '' : 'Planprüfung'"-->
                    <!--                                [icon]="faChartSimple" [selected]="'plan'"-->
                    <!--                                [routerLink]="['projects', stateConfigService.selectedProject.id, 'plan']">-->
                    <!--              </app-sidebar-item>-->
                    @if (stateConfigService.getFeatureConfig()) {
                      @if (stateConfigService.getFeatureConfig().bimIdCheck ?? false) {
                        <div class="font-medium pt-2 pl-6 text-xs text-gray-400"
                        >BIM-ID
                        </div>
                      }
                      @if (stateConfigService.getFeatureConfig().bimIdCheck ?? false) {
                        <app-sidebar-item [collapsed]="sidebarCollapsed" [icon]="faFingerprint" [opened]="sidebarOpened"
                                          [routerLink]="['projects', stateConfigService.selectedProject.id, 'bim-id']"
                                          [selected]="'bim-id'"
                                          [title]="sidebarCollapsed ? '' : 'BIM-ID'"
                                          (click)="$event.stopPropagation()"
                                          class="w-full"
                        ></app-sidebar-item>
                      }
                    }
                    <div class="font-medium pt-2 pl-6 text-xs text-gray-400">Tools</div>
                    <!--              &lt;!&ndash;          Bauantragstool&ndash;&gt;-->
                    <!--              <app-sidebar-item class="w-full" [disabled]="!applicationFromActivated()" [opened]="sidebarOpened"-->
                    <!--                                [collapsed]="sidebarCollapsed" [title]="sidebarCollapsed ? '' : 'Bauantragstool'"-->
                    <!--                                [icon]="faStamp" [selected]="'application'"-->
                    <!--                                [routerLink]="hasApplicationTool() ? ['projects', stateConfigService.selectedProject.id, 'application'] : ['projects', stateConfigService.selectedProject.id]"-->
                    <!--                                [comingSoon]="!hasApplicationTool()">-->
                    <!--              </app-sidebar-item>-->
                    <!--          IFC-Viewer-->
                    <app-sidebar-item [collapsed]="sidebarCollapsed" [icon]="faIfc" [opened]="sidebarOpened"
                                      [routerLink]="['projects', stateConfigService.selectedProject.id, 'ifc-viewer']"
                                      [selected]="'ifc-viewer'" [title]="sidebarCollapsed ? '' : 'IFC-Viewer'"
                                      class="w-full">
                    </app-sidebar-item>
                    <!--          Chat-BIC-->
                    <app-sidebar-item (click)="navigateToChat()" [collapsed]="sidebarCollapsed" [icon]="faChatbicAi"
                                      [opened]="sidebarOpened" [selected]="'chatBIC'" class="w-full"
                                      title="chatBIC">
                    </app-sidebar-item>
                  </div>
                  @if (isRulesetAdmin) {
                    <div class="flex flex-col gap-1 w-full">
                      <div class="font-medium pt-2 pl-6 text-xs text-gray-400">Admin</div>
                      <app-sidebar-item [collapsed]="sidebarCollapsed" [icon]="faShieldCheck" [opened]="sidebarOpened"
                                        [routerLink]="['admin', 'my-checks']" [selected]="'admin/my-checks'"
                                        [title]="sidebarCollapsed ? '' : 'Geteilte myChecks'"
                                        class="w-full"></app-sidebar-item>
                      <app-sidebar-item [collapsed]="sidebarCollapsed" [icon]="faShareNodes" [opened]="sidebarOpened"
                                        [routerLink]="['admin', 'check-runs']" [selected]="'admin/check-runs'"
                                        [title]="sidebarCollapsed ? '' : 'Geteilte Prüfläufe'"
                                        class="w-full"></app-sidebar-item>
                    </div>
                  }
                </app-sidebar>
                <app-sidebar-footer></app-sidebar-footer>
              </div>
            }
            <!--        Sidebar without selected project-->
            @if (authService.isLoggedIn() && stateConfigService.selectedProject == undefined && !popoutContentService.opened) {
              <div
                class="flex flex-col h-full">
                @if (stateConfigService.selectedOrganisation && stateConfigService.selectedOrganisation.logoUrl) {
                  <div class="flex flex-row justify-center items-center pb-5 pt-4">
                    <div class="flex flex-col justify-start items-center gap-1">
                      <img [src]="stateConfigService.selectedOrganisation.logoUrl"
                           alt="thinkBIC" class="h-[76px] xl:h-[76px] hover:cursor-pointer">
                      <div class="text-lg font-extrabold font-brand">planBIC</div>
                    </div>
                  </div>
                } @else {
                  <div class="flex flex-row justify-center items-center pb-5 pt-4">
                    <div class="flex flex-col justify-start items-center gap-1">
                      <img alt="thinkBIC" class="h-[76px] xl:h-[76px] hover:cursor-pointer" src="assets/logo_white.svg">
                      <div class="text-lg font-extrabold font-brand">planBIC</div>
                    </div>
                  </div>
                }
                <app-navbar class="flex flex-col w-full"></app-navbar>
                <app-sidebar [(opened)]="sidebarOpened"
                             class="flex flex-col h-full justify-between content-between overflow-hidden w-[272px]">
                  <div class="flex flex-col gap-1 w-full">
                    <div class="font-medium pt-2 pl-6 text-xs text-gray-400">Allgemein</div>
                    <app-sidebar-item [icon]="faClipboardCheck" [opened]="sidebarOpened" [routerLink]="['tasks']"
                                      [selected]="'tasks'"
                                      (click)="$event.stopPropagation()"
                                      class="w-full" title="Tasks"></app-sidebar-item>
                    <app-sidebar-item [icon]="faReport" [opened]="sidebarOpened" [routerLink]="['reports']"
                                      [selected]="'reports'"
                                      (click)="$event.stopPropagation()"
                                      class="w-full" title="Berichte"></app-sidebar-item>
                    <!--        <app-sidebar-item [beta]="true" class="w-full" [opened]="sidebarOpened" title="IFC-Viewer" [icon]="faEye"-->
                    <!--                          routerLink="ifc-viewer"></app-sidebar-item>-->
                  </div>
                  @if (isRulesetAdmin) {
                    <div class="flex flex-col gap-1 w-full">
                      <div class="font-medium pt-2 pl-6 text-xs text-gray-400">Admin</div>
                      <app-sidebar-item (click)="$event.stopPropagation()" [icon]="faShieldCheck"
                                        [opened]="sidebarOpened"
                                        [routerLink]="['admin', 'my-checks']"
                                        [selected]="'admin/my-checks'"
                                        class="w-full" title="Geteilte myChecks"></app-sidebar-item>
                      <app-sidebar-item (click)="$event.stopPropagation()" [icon]="faShareNodes"
                                        [opened]="sidebarOpened"
                                        [routerLink]="['admin', 'check-runs']"
                                        [selected]="'admin/check-runs'"
                                        class="w-full" title="Geteilte Prüfläufe"></app-sidebar-item>
                    </div>
                  }
                </app-sidebar>
                <app-sidebar-footer></app-sidebar-footer>
              </div>
            }
          </div>
        </div>
      }
      <div [ngClass]="{'bg-white rounded-sm': authService.isLoggedIn()}"
           [style.margin-right.px]="showChatFab && chatService.floatingChatOpen ? chatService.panelWidth : 0"
           class="flex-grow h-full min-w-0 overflow-hidden [container-type:inline-size] [container-name:main]">
        <div class="flex flex-col h-full">
          <div class="flex-grow h-full min-w-0">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>

      <!-- Floating chatBIC FAB -->
      @if (showChatFab) {
        <app-chat-fab></app-chat-fab>
      }

      <!-- Laufende Uploads/Loeschungen; blendet sich selbst aus, wenn nichts offen ist -->
      <app-background-activity-badge></app-background-activity-badge>
    </div>
  </div>
}
